import React from "react";
import "./LandingGalleryPreview.css";

const LandingGalleryPreview = () => {
  const galleryImages = [
    {
      img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
      title: "Luxury Sky Villa",
      location: "Mumbai, Maharashtra",
    },
    {
      img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
      title: "Modern Lake View Apartment",
      location: "Bangalore, Karnataka",
    },
    {
      img: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb",
      title: "Premium Garden Bungalow",
      location: "Delhi NCR",
    },
    {
      img: "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68",
      title: "City Center Penthouse",
      location: "Kolkata, West Bengal",
    },
    {
      img: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
      title: "Smart Studio Apartment",
      location: "Hyderabad, Telangana",
    },
    {
      img: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb",
      title: "Premium Garden Bungalow",
      location: "Delhi NCR",
    },
    {
      img: "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68",
      title: "City Center Penthouse",
      location: "Kolkata, West Bengal",
    },
    {
      img: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
      title: "Smart Studio Apartment",
      location: "Hyderabad, Telangana",
    },
  ];

  return (
    <section className="lgp-wrapper">
      <div className="lgp-header">
        <h2 className="lgp-title">Explore Premium Properties</h2>
        <p className="lgp-subtitle">
          Handpicked luxury homes designed for modern living
        </p>
      </div>

      <div className="lgp-grid">
        {galleryImages.map((item, index) => (
          <div className="lgp-card" key={index}>
            <img src={item.img} alt={item.title} />
            <div className="lgp-overlay">
              <h3>{item.title}</h3>
              <p>{item.location}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingGalleryPreview;